<template>
<div>
  
                        

          <div class="rounded-lg shadow border border-white bg-white">

            <div class="row justify-content-centre align-items-center">    
            
            <div class="col">
            <h4 class="m-3 font-weight-lighter var_color float-left"> <span class="fa fa-bars"></span> Codes-Barre    </h4> 
            </div>
            



            <div class="col">
                <div class="input-group">
                                    <select class="form-control border border-ligth " id="selected_centre" v-model="selectedCategorie">
                                            <option v-for="item in categories" :key="item.id" v-bind:value="item.id">   
                                                {{ item.nom }}
                                            </option>
                                            <option value=0>Tous</option>

                                     </select>


                                    <div class="input-group-prepend">
                                        <button @click="click_ArticlList" class="btn  btn-light  border border-ligth rounded-right" type="submit" id="button-addon1">   
                                        <span class="fa fa-search"></span> Liste
                                        </button>
                                    </div>

                </div>
            </div>



            
            <div class="col mr-2">
             <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Rechercher" class="mr-4"></b-form-input>
            </div>



            </div>
       



        <b-table 
        id="main-table"
        responsive  
        sort-icon-left
        head-variant="light"
        :filter="filter"
        :fields="fields" 
        :items="itemslist"
        :per-page="perPage"
        :current-page="currentPage"
        >
            <template #cell(actions)="row">

                    <b-button pill size="sm"  class="mr-2 mt-1 mb-1 float-right" variant="outline-primary" @click="stock_click(row.item, $event.target)">
                                <i class="fa fa-barcode"></i> 
                    </b-button>
                </template>
        
        </b-table>

                        <b-pagination
                pills
                v-model="currentPage"
                :total-rows="rows_pagin"
                :per-page="perPage"
                aria-controls="main-table"
                align="center"
                ></b-pagination>
      </div>





    <!-- les trucs public -->

    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#0179F9" loader='bars'></loading>



        <comoscodebare v-bind:nom_article="printCodBarrPars.nom_article"
                :code_barre="printCodBarrPars.code_barre"
                :prix="printCodBarrPars.prix"
                :is_solde="printCodBarrPars.is_solde"
                :solde="printCodBarrPars.solde"

        ></comoscodebare>





        </div>
        </template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import comoscodebare from '@/components/Stock/CodeBarrePrint.vue';


export default {
    computed: {
      rows_pagin() {
        return this.itemslist.length
    }
    },
    mounted(){
this.fetchFormCategorisDepots()
    },
	data () {
		return {
            selectedCategorie:'',
            filter: null,
            perPage: 10,
            currentPage: 1,
            categories:[],
            itemslist: [],
            printCodBarrPars: {
                    nom_article:'',
                    code_barre:'',
                    prix:'',
                    solde:'',
                    is_solde:'',},
            fields: [
                {key: 'ref', label: 'Article'},
                {key: 'code_bar', label: 'Code-Barre'},
                {key: 'prix_vent', label: 'Prix Vente'},
                {key: 'is_solde', label: 'Avec Solde', 
                formatter: (value) => {
                 return value ? 'Oui' : 'Non'
                }, sortable: true},
                {key: 'solde', label: 'Prix Solde'},
                {key: 'description', label: 'Description'},
                { key: 'actions', label: '' }
            ],
            //public trucs
            ModalEdit: false,
            ModalType:'Ajouter',
            isSubmitted: false,
            isLoading: false,

		}
	},
    methods :{


            stock_click(item) {

                        this.printCodBarrPars.nom_article=item.ref
                        this.printCodBarrPars.code_barre=item.code_bar
                        this.printCodBarrPars.prix=item.prix_vent
                        this.printCodBarrPars.is_solde=item.is_solde
                        this.printCodBarrPars.solde=item.solde

                        

                        this.$root.$emit('bv::show::modal', 'barcodemodal' )

        },

        fetchFormCategorisDepots: function () {
                    //chager les categories:
                    this.isLoading=true;
                    this.$http.get('/posCategors')
                    .then((result) => {
                                this.categories = result.data.data
                                this.isLoading=false;
                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });

        },

        click_ArticlList()
        {
                    if(this.selectedCategorie)
                        {

                    this.isLoading=true;
                    this.$http.get('/posArtcat/'+this.selectedCategorie)
                    .then((result) => {
                                this.itemslist = result.data.data
                                this.isLoading=false;

                                
                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });

                        }
                        else
                        {
                                        this.flashMessage.show({
                                        status: 'info',
                                        title: 'Sélectionez une Catégorie et Reésayez !!',
                                        })
                        }
        },

    },
    components: {
              Loading,
              comoscodebare  
    }
}
</script>

<style  scoped>
.var_color{
  color: #35b5e4;
}
</style>